/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-08T15:03:08.641
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getAssignedBillEditInit,
	getAssignedBillView
} from '@api/storagemanage/AssignedBill';

import {
listAssignedBillItemInit,
listAssignedBillItemByAuthorizations,
deleteAssignedBillItem
} from '@api/storagemanage/AssignedBillItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getAssignedBillEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getAssignedBillEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getAssignedBillView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getAssignedBillView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
